import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './SoftSkill.css';

const SoftSkill = ({ percentage, text }) => {
  // const percentage = 66;
  return (
    <div className="circle-container mt-10">
      <CircularProgressbar
        value={percentage}
        // text={`${percentage}%`}
        styles={buildStyles({
          textColor: '#f88',
          pathColor: '#e12457',
          trailColor: '#d6d6d6',
        })}
      />
      <div className="circle-text">{text}</div>
    </div>
  );
};

export default SoftSkill;
